import type { FeeModelCardsAdapterProps } from "modules/storyblok/adapters/FeeModelCards";
import { ChakraList as List, ChakraStack as Stack } from "@airhelp/react-ui-components";
import FeeInfoBox from "./FeeInfoBox/FeeInfoBox";
import FeeModelCard from "./FeeModelCard/FeeModelCard";

const FeeModelCards = ({ content, infoBoxText }: FeeModelCardsAdapterProps) => (
  <List maxW={{ md: "722px" }}>
    <Stack
      direction={{ base: "column", md: "row" }}
      alignItems="stretch"
      spacing={{ base: 6, lg: 8 }}
      mb={{ base: 6, md: 3 }}
      textAlign="left"
    >
      {content.map(({ _uid, heading, receiveValue, content: cardContent, action, chartValue }) => (
        <FeeModelCard
          key={_uid}
          heading={heading}
          receiveValue={receiveValue}
          content={cardContent}
          action={action}
          chartValue={chartValue}
        />
      ))}
    </Stack>
    <FeeInfoBox infoBoxText={infoBoxText} />
  </List>
);

export default FeeModelCards;
